import {Component, OnInit} from '@angular/core';
import {GoogleLoginProvider, SocialAuthService, SocialUser} from '@abacritt/angularx-social-login';
import {Router} from '@angular/router';
import {UserService} from '../services/user.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  standalone: false
})
export class SignInComponent implements OnInit {
  public socialUser: SocialUser;

  constructor(private socialAuthService: SocialAuthService, private router: Router, private userService: UserService) {
  }

  ngOnInit() {
    this.socialAuthService.authState.subscribe((user) => {
      if (user != null) {
        const url = this.userService.redirectUrl ?? "/"
        this.router.navigate([url != '/sign-in' ? url : "/"]);
      }
    });
  }

  async refreshUserToken() {
    await this.socialAuthService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }
}
